interface FormatAsCurrencyOptions extends Omit<Intl.NumberFormatOptions, 'signDisplay'> {
  addSpace: boolean | undefined;
  currency: string | undefined;
  locale: string | undefined;
  signDisplay: 'auto' | 'never' | 'always' | 'exceptZero' | 'positive';
}

// This function is used to format a number as currency.  It uses the Intl.NumberFormat object to format the
// number as currency, so all options supported by Intl.NumberFormat are supported. In addition, the following
// options are supported:
// - addSpace: If true, a space is added between the currency symbol and the number.
// - signDisplay: This option is used to determine when to display the sign of the number. In addition to the
//   values supported by Intl.NumberFormat, the following values is supported: positive.
//
// Other notes:
//   - If the value is not a valid number, it is treated as 0.0.
//   - You can set locale to undefined to use the default locale. Otherwise, default locale is 'en-US'.
//
// @ts-expect-error FIXME TS7006
export function formatAsCurrency(value, options: Partial<FormatAsCurrencyOptions> = {}) {
  const { addSpace, currency = 'USD', locale = 'en-US', signDisplay, ...other } = options;

  let valueAsNumber = value;
  if (typeof value === 'string') {
    valueAsNumber = parseFloat(value);
  }

  // Check if value is not a valid number
  if (Number.isNaN(valueAsNumber) || typeof valueAsNumber !== 'number') {
    valueAsNumber = 0.0;
  }

  let signDisplayValue = signDisplay;
  if (signDisplayValue === 'positive') {
    signDisplayValue = value > 0.005 ? 'always' : 'never';
  } else if (!signDisplayValue) {
    signDisplayValue = 'never';
  }

  let formattedValue = Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    signDisplay: signDisplayValue,
    ...other,
  }).format(valueAsNumber);

  // this only works if currency symbol is before number
  if (addSpace) {
    // second replace is to handle situation where browsers already added space
    formattedValue = formattedValue.replace(/^(\D+)/, '$1 ').replace(/\s+/, ' ');
  }

  return formattedValue;
}
